import axios from "axios";

export const state = {
    salarypayments: [],
};

export const getters = {
    salarypayments: state => state.salarypayments,
};

export const mutations = {
    setSalaryPayment(state, newValue) {
        state.salarypayments = newValue
    },
};

export const actions = {
    fetchSalaryPayment({ commit }) {
        axios.get('/salarypayments').then(res => {
            commit('setSalaryPayment', res.data.salarypayments);
        })
    },
    filterSalaryPayment({commit}, {month,year}) { 
        let formData = new FormData();
        formData.append("month", month);
        formData.append("year", year);
        let url = "/filtersalarypayments";
        axios.post(url, formData).then((response) => {
            commit('setSalaryPayment', response.data.salarypayments)
        })
    },
};
